import { render, staticRenderFns } from "./DocumentoGrid.vue?vue&type=template&id=80b3e9bc"
import script from "./DocumentoGrid.vue?vue&type=script&lang=js"
export * from "./DocumentoGrid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports